import { Table, Tooltip } from "antd";
import { Computer, ComputerPlus, NotePlus } from "../../components/icons";
import { truncateFloat } from "../../helpers/generalHelper";
import { percentHours } from "../../helpers/projectHelper";

const summaryTotal = (pageData) => {

    if (pageData.length === 0) return <></>

    const totalTimes = pageData.reduce((prev, current) => {
        prev.totalEstimated += current.timeEstimated;
        prev.totalBacklog += current.timeTotalBacklogArea;
        prev.totalSpent += current.timeTotalSpentArea;
        prev.totalTimeExtra += current.timeExtraTime;
        prev.totalTimeExtraResources += current.timeExtraResource;
        prev.totalGeneral += current.totalGeneral;
        prev.totalLeft += current.substract
        prev.totalLeftEstimated += current.substract;
        prev.totalPercentage += current.percentage;
        prev.totalProjection += current.totalGeneralProjection;
        prev.totalPercenageProjection += current.percentageProjection;
        return prev;
    }, {
        totalEstimated: 0,
        totalBacklog: 0,
        totalSpent: 0,
        totalTimeExtra: 0,
        totalTimeExtraResources: 0,
        totalGeneral: 0,
        totalLeft: 0,
        totalLeftEstimated: 0,
        totalPercentage: 0,
        totalProjection: 0,
        totalPercenageProjection: 0,
    });

    const {
        totalEstimated,
        totalBacklog,
        totalSpent,
        totalTimeExtra,
        totalTimeExtraResources,
        totalGeneral,
        totalLeft,
        totalProjection,

    } = totalTimes;
    const [{ timeEstimatedTotal } = 0] = pageData;
    const [{ percentageProject } = 0] = pageData;

    const percentage = totalGeneral === 0 ? 0 : totalEstimated === 0 ? totalGeneral * 100 : (totalGeneral * 100) / totalEstimated;
    const timeGeneralDiff = timeEstimatedTotal - totalGeneral;
    const percentageProjection = totalProjection === 0 ? 0 : totalEstimated === 0 ? totalProjection * 100 : (totalProjection * 100) / totalEstimated
    const percentageGeneralProjectionValue = totalProjection === 0 ? 0 : timeEstimatedTotal === 0 ? totalProjection * 100 : (totalProjection * 100) / timeEstimatedTotal


    const hoursPercentRemaind = percentHours(percentage, { color: "white" });
    const hoursPercent = percentHours(percentageProjection, { color: "white" });
    const timePercentageGeneral = percentHours(percentageProject, { color: "white" });
    const percentageGeneralProjection = percentHours(percentageGeneralProjectionValue, { color: "white" })



    return (
        <>
            <Table.Summary.Row className="bg-secondary text-white font-bold h-20">
                <Table.Summary.Cell index={0}>Total</Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                    <span>{truncateFloat(totalEstimated)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                    <span>{truncateFloat(totalBacklog)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                    <span>{truncateFloat(totalSpent)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                    <span>{truncateFloat(totalTimeExtra)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>
                    <span>{truncateFloat(totalTimeExtraResources)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6}>
                    <span>{truncateFloat(totalGeneral)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={7}>
                    <span>{truncateFloat(totalLeft)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}>{hoursPercentRemaind}</Table.Summary.Cell>
                <Table.Summary.Cell index={8}>
                    <span>{truncateFloat(totalProjection)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}>{hoursPercent}</Table.Summary.Cell>
            </Table.Summary.Row>
            <Table.Summary.Row style={{ backgroundColor: "black", color: "white", fontWeight: "bold" }}>
                <Table.Summary.Cell index={0}>Total General</Table.Summary.Cell>
                <Table.Summary.Cell index={1}>
                    <span>{truncateFloat(timeEstimatedTotal)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={2}>
                    <span>{truncateFloat(totalBacklog)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={3}>
                    <span>{truncateFloat(totalSpent)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={4}>
                    <span>{truncateFloat(totalTimeExtra)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={5}>
                    <span>{truncateFloat(totalTimeExtraResources)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6}>
                    <span>{truncateFloat(totalGeneral)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={6}>
                    <span>{truncateFloat(timeGeneralDiff)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}>{timePercentageGeneral}</Table.Summary.Cell>
                <Table.Summary.Cell index={8}>
                    <span>{truncateFloat(totalProjection)} hr</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell index={8}>{percentageGeneralProjection}</Table.Summary.Cell>
            </Table.Summary.Row>
        </>
    );
};

const propsColumnsScrum = () => {
    return {
        size: "large",
        scroll: { x: "100vh", y: null },
        bordered: true,
        summary: summaryTotal,
        className: "proyectionTable",
    };
};

const columnsType = () => {
    return [
        {
            title: "Nombre",
            dataIndex: "name",
            key: "name",
            render: (text) => {
                return <span>{text}</span>;
            },
        },
        {
            title: (
                <Tooltip title="Horas distribuidas de admin">
                    <span className="block w-24">Hora presupuesto</span>
                </Tooltip>
            ),
            dataIndex: "timeEstimated",
            key: "timeEstimated",
            render: (text) => {
                return <span>{truncateFloat(text || 0)} hr</span>;
            },
        },
        {
            title: (
                <Tooltip title="Horas que desarrollo estima utilizar en su backlog | Tiempo estimado">
                    <span className="block w-24">Horas estimadas</span>
                </Tooltip>
            ),
            dataIndex: "timeTotalBacklogArea",
            key: "timeTotalBacklogArea",
            render: (text) => {
                return <span>{truncateFloat(text)} hr</span>;
            },
        },
        {
            title: (
                <Tooltip title="Suma de horas trabajadas en clickup por área">
                    <span className="flex justify-center items-center gap-3 w-[96px]">
                        <div>Horas trabajadas</div>
                        <div className="w-fit">
                            <Computer color="#686868" strokeWidth="1" />
                        </div>
                    </span>
                </Tooltip>
            ),
            className: "bg-[#1677ff] hover:bg-[#1677ffcc] border border-white",
            dataIndex: "timeTotalSpentArea",
            key: "timeTotalSpentArea",
            render: (text) => {
                return <span>{truncateFloat(text)} hr</span>;
            },
        },
        {
            title: (
                <Tooltip title="Horas extras aprobadas laboradas por el equipo de desarrollo | Se cuentan al doble">
                    <span className="flex justify-center items-center gap-3 w-[96px]">
                        <div>Horas extra</div>
                        <div className="w-fit">
                            <ComputerPlus />
                        </div>
                    </span>
                </Tooltip>
            ),
            className: "bg-[#1677ff] hover:bg-[#1677ffcc] border border-white font-semibold",
            dataIndex: "timeExtraTime",
            key: "timeExtraTime",
            render: (text) => {
                return <span>{truncateFloat(text)} hr</span>;
            },
        },
        {
            title: (
                <Tooltip title="Suma de horas de recursos extras (assets - proveedores- servicios) que afectan el proyecto">
                    <span className="flex justify-center items-center gap-3 w-[96px]">
                        <div>Recursos extras</div>
                        <div className="w-fit">
                            <NotePlus />
                        </div>
                    </span>
                </Tooltip>
            ),
            className: "bg-[#1677ff] hover:bg-[#1677ffcc] border border-white font-semibold",
            dataIndex: "timeExtraResource",
            key: "timeExtraResource",
            render: (text) => {
                return <span>{truncateFloat(text)} hr</span>;
            },
        },
        {
            title: (
                <Tooltip title="Suma de horas trabajadas + horas extra + recursos extra">
                    <span className="block w-24">Total Horas consumidas</span>
                </Tooltip>
            ),
            className: "bg-[#77d075] hover:bg-[#77d075cc] border border-white",
            dataIndex: "totalGeneral",
            key: "totalGeneral",
            render: (text) => {
                return (
                    <span>{truncateFloat(text)} hr</span>
                );
            },
        },
        {
            title: (
                <Tooltip title="Diferencia de total de horas consumidas vs. horas presupuesto">
                    <span className="block w-24">Horas restantes</span>
                </Tooltip>
            ),
            className: "bg-[#77d075] hover:bg-[#77d075cc] border border-white",
            dataIndex: "substract",
            key: "substract",
            render: (text) => {
                return (
                    <>
                        <span>{truncateFloat(text)} hr</span>
                    </>
                );
            },
        },
        {
            title: (
                <Tooltip title="(Horas Consumidas x 100) / Hora presupuesto">
                    <span className="w-40 block">Porcentaje de avance actual</span>
                </Tooltip>
            ),
            dataIndex: "percentage",
            key: "percentage",
            render: (number) => {
                const status = percentHours(number);
                return <>{status}</>;
            },
        },
        {
            title: (
                <Tooltip title="No. de horas totales que se requieren por área para concluir el proyecto. Depende del estatus de la tarea incluye total de horas consumidas + backlog restante de tareas no trabajadas.">
                    <span className="block w-24">Proyección en horas</span>
                </Tooltip>
            ),
            dataIndex: "totalGeneralProjection",
            key: "totalGeneralProjection",
            render: (text) => {
                return (
                    <span>{truncateFloat(text)} hr</span>
                );
            },
        },
        {
            title: (
                <Tooltip title="La proyección de consumo de recursos por área">
                    <span className="w-40 block">Porcentaje de proyección</span>
                </Tooltip>
            ),
            dataIndex: "percentageProjection",
            key: "percentageProjection",
            render: (number) => {
                const status = percentHours(number);
                return <>{status}</>;
            },
        },
    ];
};

export const columnsProjection = () => {
    const props = propsColumnsScrum();
    const columns = columnsType();
    return {
        columns,
        props,
    };
};
